<!-- Hero Section -->
<section class="relative bg-gradient-to-br from-blue-600 via-indigo-700 to-purple-800 text-white overflow-hidden py-20 md:py-32">
  <div class="absolute inset-0 z-0">
    <div class="absolute top-0 left-0 w-1/3 h-1/3 bg-blue-400 rounded-full filter blur-3xl opacity-30 animate-pulse"></div>
    <div class="absolute bottom-0 right-0 w-1/3 h-1/3 bg-indigo-400 rounded-full filter blur-3xl opacity-30 animate-pulse"></div>
  </div>
  
  <div class="container mx-auto px-4 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div class="text-center lg:text-left">
        <div class="inline-block bg-blue-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <span class="text-sm font-medium text-blue-300">
            <i class="bx bx-briefcase mr-2"></i>Enterprise IT Services
          </span>
        </div>
        
        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Managed <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-400">IT Services</span>
        </h1>
        
        <p class="text-xl text-blue-100 mb-8 max-w-2xl mx-auto lg:mx-0">
          Transform your business operations with comprehensive managed IT services. We provide end-to-end IT infrastructure management, proactive monitoring, and expert support, allowing you to focus on your core business.
        </p>
        
        <div class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-10">
          <a routerLink="/contact" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl inline-flex items-center justify-center">
            <i class="bx bx-phone mr-2"></i>
            Contact Us
          </a>
          <a routerLink="/contact" class="bg-slate-800/30 backdrop-blur-sm text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-xl inline-flex items-center justify-center border border-slate-700/30 hover:bg-slate-700/30">
            <i class="bx bx-phone mr-2"></i>
            Get Consultation
          </a>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl mx-auto lg:mx-0">
          <div class="bg-cyan-500/10 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/30">
            <div class="text-3xl font-bold text-cyan-400 mb-1">99.9%</div>
            <div class="text-sm text-blue-200">Uptime SLA</div>
          </div>
          <div class="bg-cyan-500/10 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/30">
            <div class="text-3xl font-bold text-cyan-400 mb-1">24/7</div>
            <div class="text-sm text-blue-200">Support</div>
          </div>
          <div class="bg-cyan-500/10 backdrop-blur-sm rounded-xl p-4 border border-cyan-500/30">
            <div class="text-3xl font-bold text-cyan-400 mb-1">Expert</div>
            <div class="text-sm text-blue-200">IT Team</div>
          </div>
        </div>
      </div>
      
      <div class="relative">
        <div class="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-gray-700">
          <img src="assets/img/managed-it-hero.png" alt="Managed IT Services" class="w-full h-auto object-cover">
        </div>
        
        <div class="absolute -top-6 -left-6 bg-gradient-to-br from-cyan-600 to-blue-700 rounded-xl p-5 shadow-xl w-48">
          <div class="flex items-center">
            <i class="bx bx-desktop text-3xl mr-3"></i>
            <div>
              <div class="text-2xl font-bold">Desktop</div>
              <div class="text-xs">Support</div>
            </div>
          </div>
        </div>
        
        <div class="absolute -bottom-6 -right-6 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-xl p-5 shadow-xl w-48">
          <div class="flex items-center">
            <i class="bx bx-server text-3xl mr-3"></i>
            <div>
              <div class="text-2xl font-bold">Server</div>
              <div class="text-xs">Management</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="py-20 bg-slate-950">
  <div class="container mx-auto px-4">
    <div class="text-center mb-16">
      <div class="inline-block bg-cyan-500/10 border border-cyan-500/30 text-cyan-300 px-4 py-1 rounded-full text-sm font-medium mb-4">
        Complete IT Solutions
      </div>
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">
        Managed <span class="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-blue-600">IT Service Portfolio</span>
      </h2>
      <p class="text-xl text-slate-300 max-w-3xl mx-auto">
        Comprehensive IT management services designed to optimize your technology infrastructure, enhance security, and drive business efficiency.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <div class="bg-slate-900/70 backdrop-blur-xl rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-cyan-500/40">
        <div class="w-16 h-16 bg-gradient-to-br from-blue-600 to-indigo-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-headphone text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-blue-100 text-blue-800 text-xs font-bold px-3 py-1 rounded-full">Core</span>
        </div>
        <h3 class="text-xl font-bold text-white mb-3">IT Help Desk Support</h3>
        <p class="text-slate-300 mb-4">
          Round-the-clock technical support with remote assistance, troubleshooting, and user training for all your IT needs.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">24/7 technical support</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Remote desktop assistance</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Multi-channel support</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Ticket management system</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">User training programs</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Knowledge base access</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-slate-700/60 mb-6">
          <div>
            <div class="text-sm text-slate-400">Response Time:</div>
            <div class="font-semibold text-white">&lt; 15 minutes</div>
          </div>
          <div>
            <div class="text-sm text-slate-400">Availability:</div>
            <div class="font-semibold text-white">24/7/365</div>
          </div>
        </div>
        <div class="text-center">
          <a href="#" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 inline-block">
            Learn More
          </a>
        </div>
      </div>

      <div class="bg-slate-900/70 backdrop-blur-xl rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-cyan-500/40">
        <div class="w-16 h-16 bg-gradient-to-br from-cyan-600 to-blue-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-network-chart text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-cyan-100 text-cyan-800 text-xs font-bold px-3 py-1 rounded-full">Infrastructure</span>
        </div>
        <h3 class="text-xl font-bold text-white mb-3">Infrastructure Monitoring</h3>
        <p class="text-slate-300 mb-4">
          Proactive monitoring of servers, networks, and applications with automated alerts and performance optimization.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Real-time infrastructure monitoring</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Automated alert notifications</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Performance optimization</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Capacity planning</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Asset management</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Health dashboards</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-slate-700/60 mb-6">
          <div>
            <div class="text-sm text-slate-400">Monitoring Frequency:</div>
            <div class="font-semibold text-white">Every 5 minutes</div>
          </div>
          <div>
            <div class="text-sm text-slate-400">Uptime SLA:</div>
            <div class="font-semibold text-white">99.9%</div>
          </div>
        </div>
        <div class="text-center">
          <a href="#" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 inline-block">
            Learn More
          </a>
        </div>
      </div>

      <div class="bg-slate-900/70 backdrop-blur-xl rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-purple-500/40">
        <div class="w-16 h-16 bg-gradient-to-br from-purple-600 to-pink-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-shield-quarter text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-purple-500/20 text-purple-200 text-xs font-bold px-3 py-1 rounded-full border border-purple-500/40">Security</span>
        </div>
        <h3 class="text-xl font-bold text-white mb-3">Security Management</h3>
        <p class="text-slate-300 mb-4">
          Comprehensive cybersecurity including antivirus, firewall management, and security compliance monitoring.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Antivirus & anti-malware</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Firewall configuration</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Security patch management</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Vulnerability assessments</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Compliance monitoring</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Security reporting</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-slate-700/60 mb-6">
          <div>
            <div class="text-sm text-slate-400">Threat Response:</div>
            <div class="font-semibold text-white">&lt; 10 minutes</div>
          </div>
          <div>
            <div class="text-sm text-slate-400">Security Scans:</div>
            <div class="font-semibold text-white">Daily</div>
          </div>
        </div>
        <div class="text-center">
          <a href="#" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 inline-block">
            Learn More
          </a>
        </div>
      </div>

      <div class="bg-slate-900/70 backdrop-blur-xl rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-emerald-500/40">
        <div class="w-16 h-16 bg-gradient-to-br from-green-600 to-emerald-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-cloud-download text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-emerald-500/20 text-emerald-200 text-xs font-bold px-3 py-1 rounded-full border border-emerald-500/40">Backup</span>
        </div>
        <h3 class="text-xl font-bold text-white mb-3">Backup & Recovery</h3>
        <p class="text-slate-300 mb-4">
          Automated backup solutions and disaster recovery planning to ensure business continuity and data protection.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Automated daily backups</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Cloud backup storage</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Disaster recovery planning</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Point-in-time recovery</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Backup verification</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Recovery testing</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-slate-700/60 mb-6">
          <div>
            <div class="text-sm text-slate-400">RTO:</div>
            <div class="font-semibold text-white">&lt; 4 hours</div>
          </div>
          <div>
            <div class="text-sm text-slate-400">RPO:</div>
            <div class="font-semibold text-white">&lt; 1 hour</div>
          </div>
        </div>
        <div class="text-center">
          <a href="#" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 inline-block">
            Learn More
          </a>
        </div>
      </div>

      <div class="bg-slate-900/70 backdrop-blur-xl rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-amber-500/40">
        <div class="w-16 h-16 bg-gradient-to-br from-amber-600 to-orange-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-server text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-amber-500/20 text-amber-200 text-xs font-bold px-3 py-1 rounded-full border border-amber-500/40">Maintenance</span>
        </div>
        <h3 class="text-xl font-bold text-white mb-3">Server Management</h3>
        <p class="text-slate-300 mb-4">
          Complete server administration including updates, patches, performance tuning, and maintenance scheduling.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Server provisioning</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Operating system updates</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Performance optimization</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Resource monitoring</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Maintenance scheduling</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Configuration management</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-slate-700/60 mb-6">
          <div>
            <div class="text-sm text-slate-400">Patch Frequency:</div>
            <div class="font-semibold text-white">Monthly</div>
          </div>
          <div>
            <div class="text-sm text-slate-400">Maintenance Window:</div>
            <div class="font-semibold text-white">Scheduled</div>
          </div>
        </div>
        <div class="text-center">
          <a href="#" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 inline-block">
            Learn More
          </a>
        </div>
      </div>

      <div class="bg-slate-900/70 backdrop-blur-xl rounded-2xl shadow-xl p-8 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-rose-500/40">
        <div class="w-16 h-16 bg-gradient-to-br from-rose-600 to-pink-700 rounded-2xl flex items-center justify-center mb-6">
          <i class="bx bx-mobile text-3xl text-white"></i>
        </div>
        <div class="mb-3">
          <span class="bg-rose-500/20 text-rose-200 text-xs font-bold px-3 py-1 rounded-full border border-rose-500/40">Mobile</span>
        </div>
        <h3 class="text-xl font-bold text-white mb-3">Mobile Device Management</h3>
        <p class="text-slate-300 mb-4">
          Comprehensive mobile device management with security policies, app management, and BYOD support.
        </p>
        <ul class="space-y-2 mb-6">
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Device enrollment</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Security policy enforcement</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">App management</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">BYOD support</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Remote wipe capability</span>
          </li>
          <li class="flex items-center text-slate-200">
            <i class="bx bx-check text-blue-600 mr-2"></i>
            <span class="text-sm">Compliance reporting</span>
          </li>
        </ul>
        <div class="grid grid-cols-2 gap-4 pt-4 border-t border-slate-700/60 mb-6">
          <div>
            <div class="text-sm text-slate-400">Device Platforms:</div>
            <div class="font-semibold text-white">iOS, Android</div>
          </div>
          <div>
            <div class="text-sm text-slate-400">Policy Enforcement:</div>
            <div class="font-semibold text-white">Real-time</div>
          </div>
        </div>
        <div class="text-center">
          <a href="#" class="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 inline-block">
            Learn More
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="relative bg-gradient-to-br from-cyan-600 via-blue-700 to-indigo-800 text-white overflow-hidden py-20">
  <div class="absolute inset-0 z-0">
    <div class="absolute top-0 right-0 w-96 h-96 bg-cyan-400 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
    <div class="absolute bottom-0 left-0 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl opacity-20 animate-pulse"></div>
  </div>
  
  <div class="container mx-auto px-4 relative z-10">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <div>
        <h2 class="text-3xl md:text-4xl font-bold mb-6">Transform Your <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-cyan-300">IT Infrastructure</span></h2>
        <p class="text-xl text-blue-100 mb-8">
          Let our expert IT team manage your technology infrastructure while you focus on growing your business. Get enterprise-grade IT management with 99.9% uptime guarantee and 24/7 support.
        </p>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div class="flex items-center">
            <div class="bg-white/20 backdrop-blur-sm p-3 rounded-lg mr-4">
              <i class="bx bx-time text-2xl"></i>
            </div>
            <div>
              <div class="font-semibold">24-hour setup</div>
              <div class="text-sm text-blue-200">Get started</div>
            </div>
          </div>
          
          <div class="flex items-center">
            <div class="bg-white/20 backdrop-blur-sm p-3 rounded-lg mr-4">
              <i class="bx bx-support text-2xl"></i>
            </div>
            <div>
              <div class="font-semibold">24/7 Support</div>
              <div class="text-sm text-blue-200">Expert help</div>
            </div>
          </div>
          
          <div class="flex items-center">
            <div class="bg-white/20 backdrop-blur-sm p-3 rounded-lg mr-4">
              <i class="bx bx-time text-2xl"></i>
            </div>
            <div>
              <div class="font-semibold">99.9% Uptime</div>
              <div class="text-sm text-blue-200">Guaranteed</div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="space-y-4">
        <a routerLink="/sign-up" class="block bg-white text-cyan-600 font-bold py-4 px-6 rounded-xl text-center hover:bg-gray-100 transition-all duration-300 transform hover:-translate-y-1 shadow-xl hover:shadow-2xl">
          <i class="bx bx-cog text-xl mr-2"></i>
          <span class="text-lg">Start Management</span>
          <div class="text-sm font-normal text-gray-600 mt-1">Free consultation included</div>
        </a>
        
        <a routerLink="/contact" class="block bg-transparent border-2 border-slate-700/50 text-white font-bold py-4 px-6 rounded-xl text-center hover:bg-slate-700/20 transition-all duration-300">
          <i class="bx bx-phone text-xl mr-2"></i>
          <span class="text-lg">Schedule Demo</span>
          <div class="text-sm font-normal text-blue-200 mt-1">See our platform</div>
        </a>
        
        <div class="bg-slate-800/30 backdrop-blur-sm rounded-xl p-4 text-center border border-slate-700/30">
          <i class="bx bx-badge-check text-3xl mb-2"></i>
          <div class="font-semibold">99.9% Uptime Guaranteed</div>
        </div>
      </div>
    </div>
  </div>
</section>
